import { PRINT_BLEED_CENTER_GAP_PT, PRINT_BLEED_MARGIN_PT } from '@/lib/document/print-bleed'
import type { DocumentLayoutState } from '../types/document-layout-state'

export const DEFAULT_DOCUMENT_LAYOUT: DocumentLayoutState = {
  // Size 8 (8.5×11): 612 pt page width, 1224 pt spread trim.
  pageTrimWidth: 612,
  pageTrimHeight: 792,
  bleedMargin: PRINT_BLEED_MARGIN_PT,
  centerGap: PRINT_BLEED_CENTER_GAP_PT,
  liveInset: 28,
  marginInside: 0,
  marginOutside: 28,
  marginTop: 28,
  marginBottom: 28,
}
